import {Component, Input, OnInit} from '@angular/core';
import {IActivity} from "../../activities/activity";

@Component({
    selector: 'db-action-progress',
    templateUrl: './action-progress.component.html',
    styleUrls: ['./action-progress.component.scss'],
    standalone: false
})
export class ActionProgressComponent implements OnInit {

  @Input() ongoingActivity: IActivity;
  @Input() size: 'sm'|'normal';
  @Input() customClass?: any;

  public spinnerSize: number;

  constructor() {}

  ngOnInit(): void {
    this.size = this.size || 'normal';

    this.defineSpinnerSize();
  }

  private defineSpinnerSize(): void {
    switch (this.size) {
      case 'sm':
        this.spinnerSize = 36;
        break;
      case 'normal':
        this.spinnerSize = 66;
        break;
    }
  }

}
